<template>
  <div>
    <h3 class="text-center font-weight-bold title">Сертификат поиска</h3>
    <br />

    <h6 class="text-left font-weight-bold subtitle">Информация о поиске</h6>
    <br />
    <div style="">
      <div v-if="getSearchTerm" class="row">
        <div class="col-3 font-weight-bold subline"><strong>Поиск</strong></div>
        <div class="col-9 text">{{ getSearchTerm }}</div>
      </div>
      <div v-if="getCreatedAt" class="row">
        <div class="col-3 font-weight-bold subline">
          <strong>Дата создания</strong>
        </div>
        <div class="col-9 text">{{ getCreatedAt }}</div>
      </div>
      <div v-if="getCreatedBy" class="row">
        <div class="col-3 font-weight-bold subline"><strong>ФИО</strong></div>
        <div class="col-9 text">{{ getCreatedBy() }}</div>
      </div>
      <div v-if="getCountryCodes" class="row">
        <div class="col-3 font-weight-bold subline">
          <strong>Страны</strong>
        </div>
        <div class="col-9 text">{{ getCountryCodes }}</div>
      </div>
      <div v-if="getFuzziness" class="row">
        <div class="col-3 font-weight-bold subline">
          <strong>Нечеткость</strong>
        </div>
        <div class="col-9 text">{{ getFuzziness }}%</div>
      </div>
      <div v-if="getEnt" class="row">
        <td class="col-3 font-weight-bold subline">
          <strong>Тип объекта</strong>
        </td>
        <td class="col-9 text">{{ getEnt }}</td>
      </div>
      <div v-if="getEnt" class="row">
        <div class="col-3 font-weight-bold subline"><strong>Типы</strong></div>
        <div class="col-9 text"></div>
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-3"></div> -->

      <div class="col-3" style="">
        <div v-for="tp in matchTypes" class="badge badge-warning">
          <div>{{ getResponseType(tp) }}</div>
        </div>
      </div>
      <!-- <div class="col-6"></div> -->
    </div>
    <br />

    <h6 class="text-left font-weight-bold subtitle">Результаты поиска</h6>
    <br />

    <div id="ca-results">
      <div v-for="hits in grouped_results_hits()" class="row">
        <div
          v-for="hit in hits"
          class="col-lg-6 d-flex align-items-stretch"
          style="padding-top: 10px"
        >
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-10">
                  <div
                    class="card-header card-header-primary"
                    syle="text-align: left; !important"
                  >
                    {{ getEntityName(hit.doc.entity_type) }}
                  </div>
                </div>
              </div>
              <br />
              <h5 class="btn-link card-title" @click="openAML(hit)">
                {{ hit.doc.name }}
              </h5>
              <br />
              <div style="">
                <div class="row">
                  <div class="col-lg-6" style="font-weight: bold">
                    {{ $t("message.comply_advantage.matched_label") }}
                  </div>
                  <div class="col-lg-6">
                    <div
                      v-for="tp in hit.doc.types"
                      class="badge badge-warning"
                    >
                      <p hidden></p>
                      {{ getResponseType(tp) }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6" style="font-weight: bold">
                    {{ $t("message.comply_advantage.relevance_label") }}
                  </div>
                  <div class="col-lg-6">
                    <!--<div v-for="t in hit.match_types"> -->
                    {{ getRelevance(hit.match_types) }},
                    <!--</div> -->
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6" style="font-weight: bold">
                    {{ $t("message.comply_advantage.countries_label") }}
                  </div>
                  <div class="col-lg-6">
                    {{ getCountries(hit.doc.fields) }}
                  </div>
                </div>
                <div v-if="hit.doc.entity_type == 'person'" class="row">
                  <div class="col-lg-6" style="font-weight: bold">
                    {{ $t("message.comply_advantage.dob_label") }}
                  </div>
                  <div class="col-lg-6">
                    {{ getDateOfBirth(hit.doc.fields) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      aml: [],
      person: { given_name: "", last_name: "" },
    };
  },
  mounted() {
    //console.log('aml pdf doc_additional', this.doc_additional);
    // moment.locale(this.i18n.locale=='cn'?'zh-cn':'ru', this.i18n.locale=='cn'?zh:ru);
    moment.locale("ru");
    setTimeout(() => {
      this.$root.$emit("print-pdf", { signature: "", type: "aml-overall" });
    }, 2000);
    axios.get(window.base + "/document/getfirmfull").then((response) => {
      this.person = response.data.persons;
    });
  },
  methods: {
    getCreatedBy() {
      return this.person.last_name + " " + this.person.given_name;
    },
    /**
     * proxy to call external function in template
     */

    number_to_letters(val) {
      if (this.$i18n.locale == "en") return window.number_to_letters_en(val);
      else return window.number_to_letters(val);
    },
    getEntityName(entity) {
      return this.$t(
        "message.comply_advantage.response_entity_type_" + entity.trim(),
      );
    },
    grouped_results_hits() {
      return _.chunk(this.ungroupedhits, 2);
    },
    getRelevance(types) {
      // var res = '';
      // types.forEach(type => {
      //     res = res + this.$t('message.comply_advantage.response_relevance_' + type.trim()) + ', ';
      // })
      return types
        .map((type) => {
          return this.$t(
            "message.comply_advantage.response_relevance_" + type.trim(),
          );
        })
        .join(",");
    },

    isValidUrl(str) {
      var a = document.createElement("a");
      a.href = str;
      return a.host && a.host != window.location.host;
    },
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    /**
     * proxy to call external function in template
     */
    days_to_letters(val) {
      if (this.$i18n.locale == "en") return window.days_to_letters_en(val);
      else return window.days_to_letters(val);
    },
    /**
     * proxy to call external function in template
     */
    money_letters(val, cur) {
      if (this.$i18n.locale == "en") return window.money_letters_en(val, cur);
      else return window.money_letters(val, cur);
    },
    /**
     * proxy to call external function in template
     */
    percent_to_letters(val) {
      if (this.$i18n.locale == "en") return window.percent_to_letters_en(val);
      else return window.percent_to_letters(val);
    },
    getCountries(fields) {
      fields = fields.filter((field) => field.name.trim() === "Countries");
      fields = fields.map((field) => {
        return field.value;
      });
      return fields[0];
    },
    getNames(aka) {
      //fields = fields.filter(field => field.name.trim() === 'Countries')
      aka = aka.map((field) => {
        return field.name;
      });
      return aka[0];
    },
    getDateOfBirth(fields) {
      var dobs = fields.filter(
        (field) => field.name.trim() === "Date of Birth",
      );
      if (typeof dobs[0] != "undefined") return dobs[0].value;
      else return "";
    },
    getResponseTypes(types) {
      return types
        .map((type) => {
          return this.$t(
            "message.comply_advantage.response_match_" + type.trim(),
          );
        })
        .join(",");
    },
    getResponseType(type) {
      return this.$t("message.comply_advantage.response_match_" + type.trim());
    },
  },
  watch: {},
  computed: {
    ungroupedhits() {
      if (
        this.doc !== false &&
        typeof this.doc.content.data.hits[0] !== "undefined"
      )
        return this.doc.content.data.hits;
      return {};
    },
    matchTypes() {
      if (
        this.doc !== false &&
        typeof this.doc.content.data.filters.types !== "undefined"
      )
        return this.doc.content.data.filters.types;
      return {};
    },
    getFuzziness() {
      if (typeof this.doc !== "undefined" || this.doc != false) {
        if (typeof this.doc.content.data.filters.fuzziness !== "undefined")
          return parseFloat(this.doc.content.data.filters.fuzziness) * 100;
      }

      return false;
    },
    getSearchTerm() {
      if (typeof this.doc !== "undefined" || this.doc != false) {
        if (typeof this.doc.content.data.search_term !== "undefined")
          return this.doc.content.data.search_term;
      }
      return false;
    },
    getCreatedAt() {
      if (typeof this.doc !== "undefined" || this.doc != false) {
        if (typeof this.doc.content.data.created_at !== "undefined")
          return this.doc.content.data.created_at;
      }
      return false;
    },
    getCountryCodes() {
      if (typeof this.doc !== "undefined" || this.doc != false) {
        if (typeof this.doc.content.data.filters.country_codes !== "undefined")
          return this.doc.content.data.filters.country_codes.join(", ");
      }
      return false;
    },
    getEnt() {
      if (typeof this.doc !== "undefined" || this.doc != false) {
        if (typeof this.doc.content.data.filters.entity_type !== "undefined")
          return this.getEntityName(this.doc.content.data.filters.entity_type);
      }
      return false;
    },
  },
};
</script>
<style scoped>
.title {
  line-height: 1.5 !important;
  color: black;
  font-weight: 500 !important;
}
.subline {
  line-height: 1.2 !important;
  font-size: 14px;
  font-weight: 400 !important;
  color: #37517e;
}
.subtitle {
  font-size: 16px;
  font-weight: 500 !important;
  color: black;
}
.text {
  font-size: 14px;
  color: black;
}
.html2pdf__page-break {
  page-break-before: always;
}
</style>
